// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".satisfi_error {\r\n  position: absolute;\r\n  z-index: 99999;\r\n  left: calc(50% - var(--chatWidth) / 2);\r\n  top: 0;\r\n  right: auto;\r\n  bottom: 0;\r\n  width: var(--chatWidth);\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 18px;\r\n  font-family: var(--chatFontFamily);\r\n  background-color: var(--errorContainerBgColor);\r\n}\r\n\r\n.satisfi_errorMessage {\r\n  color: var(--errorTextColor);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
